import { Box } from '@wix/design-system';
import React, { FunctionComponent } from 'react';

import { ChineseNotification } from './ChineseNotification';
import { LanguageSupportedNotification } from './LanguageSupportedNotification';
import { StatusPageNotification } from './StatusPageNotification';
import { PageType } from '../../types';

import css from './index.module.scss';

type NotificationBarProps = {
  pageType: PageType;
};

export const NotificationBar: FunctionComponent<NotificationBarProps> = ({
  pageType,
}) => (
  <Box className={css.notificationBar} direction="vertical">
    {pageType !== PageType.RoadMap && (
      <LanguageSupportedNotification pageType={pageType} />
    )}
    <ChineseNotification pageType={pageType} />
    <StatusPageNotification pageType={pageType} />
  </Box>
);
